import React, { Component } from 'react';
import TopBar from './topbar.js';
import LeftSideBar from './leftsidebar.js';
import RightContent from './rightcontent.js';


export default class Dashboard extends Component {

  render() {
    const data = this.props.data;
    const switchLanguage = this.props.switchLanguage;

    return (
      <div id="wrapper">
        <TopBar data={data.topbar} switchLanguage={switchLanguage}/>
        <LeftSideBar data={data.leftsidebar}/>
        <RightContent name={this.props.page.params.name} data={data}/>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js